<div class="tool-content-container">
  <div class="tool-description">
    Select <instruction-step-link link="student-type" text="Student Type" />,
    <instruction-step-link link="semesters" text="Semester" />, Number of
    Courses, and
    <instruction-step-link link="course-level" text="Course Level(s)" />, and
    click submit to generate course combinations results.
    <!-- <b class="instructions-title"
      >To generate results for course combinations:</b
    ><br />
    Step 1 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="student-type" text="Student Type" />
    <br />
    Step 2 <i class="fa-solid fa-arrow-right"></i> Select a
    <instruction-step-link link="semesters" text="Semester" />
    <br />
    Step 3 <i class="fa-solid fa-arrow-right"></i> Select Number of Courses<br />
    Step 4 <i class="fa-solid fa-arrow-right"></i> Select
    <instruction-step-link link="course-level" text="Course Level(s)" />
    <br />
    Step 5 <i class="fa-solid fa-arrow-right"></i> Click on the submit button<br /><br /> -->

    <!-- <b class="warning-note">
      *If course is not found, then the minimum enrollment threshold is not met
      for pass rate prediction.
    </b> -->
  </div>

  <div class="course-combo-filters" *ngIf="tableData.data?.length">
    <mat-form-field
      class="course-filter-input"
      *ngFor="let item of formItems.controls; let i = index"
    >
      <mat-label>Filter course {{ i + 1 }}</mat-label>
      <input
        type="text"
        matInput
        [matAutocomplete]="auto"
        [(ngModel)]="item.get('course')!.value"
        (ngModelChange)="applyFilter(item, 'course_' + (i + 1).toString())"
      />
      <button
        *ngIf="item.get('course')!.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="
          item.get('course')!.patchValue('');
          applyFilter(item, 'course_' + (i + 1).toString())
        "
      >
        <i class="fas fa-times-circle"></i>
      </button>
      <mat-autocomplete #auto="matAutocomplete" class="course-list-container">
        <cdk-virtual-scroll-viewport
          class="autocomplete-test-viewport"
          [style]="{
            height: calculateFilterDropdownHeight(
              item.get('filteredCourses')?.value
            ),
          }"
          itemSize="25"
        >
          <mat-option
            *cdkVirtualFor="let course of item.get('filteredCourses')!.value"
            [value]="course"
            class="autocomplete-item"
          >
            {{ course }}
          </mat-option>
        </cdk-virtual-scroll-viewport>
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div
    *ngIf="tableData?.data?.length && !mobileView"
    class="course-combo-content-container mat-elevation-z8 table-parent-div"
  >
    <div>
      <table mat-table class="table-container" [dataSource]="tableData" matSort>
        <!-- No. Column -->
        <ng-container matColumnDef="no">
          <th mat-header-cell *matHeaderCellDef mat-sort-header>No.</th>
          <td mat-cell *matCellDef="let element">{{ element.no }}</td>
        </ng-container>

        <!-- Course 1 Column -->
        <ng-container
          *ngIf="courseCombosData.combo_size >= 1"
          matColumnDef="course_1"
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Course 1</th>
          <td mat-cell *matCellDef="let element">{{ element.course_1 }}</td>
        </ng-container>

        <!-- Course 2 Column -->
        <ng-container
          *ngIf="courseCombosData.combo_size >= 2"
          matColumnDef="course_2"
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Course 2</th>
          <td mat-cell *matCellDef="let element">{{ element.course_2 }}</td>
        </ng-container>

        <!-- Course 3 Column -->
        <ng-container
          *ngIf="courseCombosData.combo_size >= 3"
          matColumnDef="course_3"
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Course 3</th>
          <td mat-cell *matCellDef="let element">{{ element.course_3 }}</td>
        </ng-container>

        <!-- Course 4 Column -->
        <ng-container
          *ngIf="courseCombosData.combo_size >= 4"
          matColumnDef="course_4"
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Course 4</th>
          <td mat-cell *matCellDef="let element">{{ element.course_4 }}</td>
        </ng-container>

        <!-- Course 5 Column -->
        <ng-container
          *ngIf="courseCombosData.combo_size >= 5"
          matColumnDef="course_5"
        >
          <th mat-header-cell *matHeaderCellDef mat-sort-header>Course 5</th>
          <td mat-cell *matCellDef="let element">{{ element.course_5 }}</td>
        </ng-container>

        <!-- Pass Rate Column -->
        <ng-container matColumnDef="pass_rate">
          <th mat-header-cell mat-sort-header *matHeaderCellDef>Pass Rate</th>
          <td mat-cell *matCellDef="let element">{{ element.pass_rate }}</td>
        </ng-container>

        <tr
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
      </table>
    </div>
  </div>

  <!-- Moble View -->
  <div *ngIf="tableData?.data?.length && mobileView">
    <mat-table
      [dataSource]="tableData"
      class="mat-elevation-z8 table-container"
    >
      <ng-container
        *ngFor="let col of displayedColumns; index as i"
        [matColumnDef]="col"
      >
        <mat-header-cell *matHeaderCellDef>{{ col }}</mat-header-cell>
        <mat-cell *matCellDef="let element"
          ><span>{{ col }}:</span>{{ element[col] }}</mat-cell
        >
      </ng-container>

      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>
  </div>

  <b class="warning-note" *ngIf="!tableData?.data?.length">
    No data available for the selected filters. The minimum enrollment threshold
    is not met for pass rate prediction. Please adjust your selections.
  </b>

  <back-button></back-button>
</div>
